export default __webpack_public_path__ + "static/media/about_icon1.e97b8f6f.svg";